import { UcoastEl } from '@/scripts/core/UcoastEl'
import { TsDOM as q } from '@/scripts/core/TsDOM'
import { Filters } from '@/scripts/interactive-defer/filters'
export class FacetRemove extends UcoastEl {
	static htmlSelector = 'facet-remove';
	reset: boolean
	constructor() {
		super();
		this.reset = this.hasAttribute('data-reset');
		const facetLink = q.rs('a', this);
		facetLink.setAttribute('role', 'button');
		facetLink.addEventListener('click', this.closeFilter.bind(this));
		facetLink.addEventListener('keyup', (event) => {
			event.preventDefault();
			if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
		});
	}

	closeFilter(event: KeyboardEvent) {
		event.preventDefault();
		Filters.onActiveFilterClick(event, this.reset);
	}
}

